import { render, staticRenderFns } from "./SepultamentoModal.vue?vue&type=template&id=2ce61a5c&scoped=true&"
import script from "./SepultamentoModal.vue?vue&type=script&lang=js&"
export * from "./SepultamentoModal.vue?vue&type=script&lang=js&"
import style0 from "./SepultamentoModal.vue?vue&type=style&index=0&id=2ce61a5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce61a5c",
  null
  
)

export default component.exports